import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {updateDataUser} from "../js/actions/index";
import "./teoria.scss";

function mapStateToProps(state){
	let videoVisto = (state.login.user && state.login.user.acf && state.login.user.acf.videovisto)?parseInt(state.login.user.acf.videovisto):0;
	return({
		videoVisto: videoVisto,
		token: state.login.token,
	});
}
function masDispatchToProps(dispatch){
	return{
		updateDataUser:(field,value)=>dispatch(updateDataUser({field,value})),
	};
}
class Teoria extends Component {
	static propTypes = {
		videoVisto:PropTypes.number,
		token:PropTypes.string,
		updateDataUser:PropTypes.func,
	}
	state = {
		video: -1,
	}
	videos= [
		{
			categoria:"1.INTRODUCCIÓN",
			titulo:"INTRODUCCIÓN, JUSTIFICACIÓN, LEGISLACIÓN ENTORNO A LA ECOGRAFÍA",
			miniatura:"01 Introduccion, Justificacion, legislacion ecografia.png",
			video:"intro",
		},
		{
			categoria:"2.INTRODUCCIÓN",
			titulo:"POR QUÉ HACER ECOGRAFÍA",
			miniatura:"02 por que hacer ecografia.png",
			video:"porque",
		},
		{
			categoria:"1.BASES DE LA ECOGRAFIA",
			titulo:"BASES FÍSICAS DEL SONIDO",
			miniatura:"01 bases fisicas del sonido.png",
			video:"bases",
		},
		{
			categoria:"2.BASES DE LA ECOGRAFIA",
			titulo:"TERMINOLOGÍA, PROTOCOLO Y PATRONES ECOGRÁFICOS",
			miniatura:"02 terminologia, protocolo y patrones.png",
			video:"terminos",
		},
		{
			categoria:"3.BASES DE LA ECOGRAFIA",
			titulo:"ARTEFACTOS",
			miniatura:"03 artefactos.png",
			video:"artefactos",
		},
		{
			categoria:"4.BASES DE LA ECOGRAFIA",
			titulo:"RESUMEN",
			miniatura:"04 resumen.png",
			video:"resumen",
		},
	]
	cargaVideo = (video) => {
		if(video >= this.props.videoVisto){
			this.props.updateDataUser("videovisto",video+1);
		}
		this.setState({video:video});
	}
	render(){
		let menu = this.videos.map((item,index) => {
			let clase = "videoThumb";
			if(this.state.video === index) clase += " on";
			if(index > parseInt(this.props.videoVisto)) clase += " off";
			return <div key={"vid_"+index} className={clase} onClick={() => this.cargaVideo(index)}>
				<div className="miniatura"><img alt={item.titulo} src={"content/teoria/"+item.miniatura}/></div>
				<div className="categoria">{item.categoria}</div>
				<div className="titulo">{item.titulo}</div>
			</div>;
		});
		let video = this.state.video < 0?
			<p>Seleccione un vídeo para iniciar su reproducción</p>:
			<>
			<div className="categoria">{this.videos[this.state.video].categoria}</div>
			<div className="titulo">{this.videos[this.state.video].titulo}</div>
			<video key={this.videos[this.state.video].video} width="100%" controls>
				<source src={"content/teoria/"+this.videos[this.state.video].video+".mp4"} type="video/mp4"/>
				<source src={"content/teoria/"+this.videos[this.state.video].video+".WebM"} type="video/webm"/>
			</video>
			<a href={"content/teoria/"+this.videos[this.state.video].video+".mp4"} target="_new">descargar vídeo</a>
			</>;
		return <div className="teoria">
			
			<div className="menuVideos">{menu}</div>
			<div className="video">
				<h1>Teoría</h1>
				{video}
			</div>
		</div>;
	}
}

export default connect(mapStateToProps,masDispatchToProps)(Teoria);